

import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
const ICON_SIZE = 29;
export const   ConnectorTouchingIcon = styled(StepConnector)(({  }) => ({
  
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: ICON_SIZE / 2, 
    left: `calc(-50% + ${ICON_SIZE / 2}px)`,
    right: `calc(50% + ${ICON_SIZE / 2}px)`,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderTopWidth: 5,                    
    borderRadius: 1,
  },
}));
